import styled from 'styled-components';
import { P1 } from '../../styles/FontStyles';
import { Div } from '../../styles/Styles';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';

import google from '../../assets/images/google.png';
import { ErrorToast } from 'components/Toasts/Toasts';
import { useAppDispatch } from 'app/hooks';
import { signInGoogle } from 'services/auth/auth.service';
import { useNavigate } from 'react-router-dom';
import { decodeJwt } from 'helpers/helpers';

const GoogleButtonStyle = styled.button`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 12px;
  background: rgba(255, 171, 150, 0.8);
  color: ${({ theme }) => theme.white};
  border: none;
`;

export const GoogleButton = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <GoogleLogin
      shape='pill'
      text='signin_with'
      size='large'
      width={'100%'}
      onSuccess={(credentialResponse) => {
        dispatch(
          signInGoogle({
            googleIdToken: credentialResponse.credential,
            navigate,
          })
        );
      }}
      onError={() => {
        console.log('Login Failed');
      }}
    />
  );
};
